import styled from 'styled-components'

const BakaWrapper = styled.div`
  position: relative;
  background: ${props => props.theme.colors[props.theme.mode].bg};
  padding-top: 4rem;
  padding-bottom: 4rem;
`

export default BakaWrapper
